import { InputNumber } from "antd";
import classNames from "classnames";
import Button from "components/shared/button";
import { Text } from "components/shared/text";
import { PropsWithChildren } from "react";

export const QuantityWidgetWrapper: React.FC<
  PropsWithChildren<{ isSelected?: boolean }>
> = ({ isSelected, children }) => {
  return (
    <group data-wrap="no" data-align="center" data-space="10">
      <group data-height="40" data-align="center" data-length="70">
        <Text data-position="left" data-weight="700" data-ellipsis="">
          quantite
        </Text>
      </group>

      <group
        data-radius="5"
        data-length="160"
        data-direction="row"
        data-justify="center"
        data-wrap="no"
        data-space="5"
        data-gap="5"
        data-align="center"
        className={classNames("quantityWidget", {
          light: !isSelected,
          dark: isSelected,
        })}
        data-text-size="large"
        data-weight="400"
      >
        {children}
      </group>
    </group>
  );
};

export const AccessoireSup2QuantityWidget: React.FC<{
  isSelected?: boolean;
  value?: number;
  max?: number;
  min?: number;
  onDecrease: () => void;
  onIncrease: () => void;
  onChange: () => void;
}> = ({ isSelected, value, max, min, onDecrease, onIncrease, onChange }) => {
  return (
    <QuantityWidgetWrapper isSelected={isSelected}>
      <>
        <Button
          micro
          outline
          icon="remove"
          disabled={!value || value === min}
          onClick={onDecrease}
        />
        <InputNumber
          variant="borderless"
          controls={false}
          type="number"
          data-length="50"
          style={{
            fontSize: "18px",
            fontWeight: 400,
            color: "white",
          }}
          value={value}
          placeholder="0"
          max={max}
          min={0}
          onChange={onChange}
        />
        <Button
          micro
          outline
          icon="add"
          disabled={!!max && (value as number) >= max}
          onClick={() => onIncrease}
        />
      </>
    </QuantityWidgetWrapper>
  );
};
